import { FocusableElement } from '@react-types/shared';
import React, { DOMAttributes } from 'react';

export interface ModalLayoutContextProps {
  /**
   * Props that should be applied to the modal title, to make the entire modal labeled by it.
   */
  titleProps: DOMAttributes<FocusableElement>;

  /**
   * Called when the close button in the header is pressed.
   */
  onClose?: () => void;
}

/**
 * Rendered in modal components to provide modal props that are needed in modal layout parts.
 * @internal
 */
export const ModalLayoutContext = React.createContext<ModalLayoutContextProps>({
  titleProps: {},
  onClose: () => {
    // eslint-disable-next-line no-console
    console.error(
      new Error(
        'ModalLayout close action is not handled. ModalLayout is meant to be rendered inside modal components.'
      )
    );
  },
});
